/*
 * Map filters and query into a simple "Showing results for" bar
 * that appears above the results
 *
 * https://www.algolia.com/doc/api-reference/widgets/current-refinements/js/
 */
import { connectCurrentRefinements } from 'instantsearch.js/es/connectors'
import { renderListItem } from "../../../../shared/js/algolia/templates/refinementList";
/*
 * Item template. We're only returning the value in an inline element
 */

const renderCurrentRefinements = (renderOptions, isFirstRender) => {
  const { items } = renderOptions;
  /*
   * Adjust the starting label depending on if we do have
   * any matched results. This replaces the need for the
   * stats widget entirely rather than doing a complex hide/show
   * of a series of similar TTEC Solutions
   */
  const helper = renderOptions.instantSearchInstance.helper ?? null;
  let hits = 0;
  if(helper) {
    hits = helper.lastResults.nbHits
  }
  const label = hits > 0 ? 'Showing results for:' : 'No results for:';

  /*
   * Adds the markup to the DOM based on the widget settings below
   * Applies the label set above and iterates over each refinement and
   * query adding a "+" between each
   */
  document.querySelector('[data-ttecsolutions-current-refinements]').innerHTML = `${label}
      ${items.map(renderListItem).join('+')}
  `;
};

// Create the custom widget
const customRefinement = connectCurrentRefinements(renderCurrentRefinements)
export const ttecSolutionsCurrentRefinements = customRefinement({
  container: '[data-ttecsolutions-current-refinements]',
  excludedAttributes: [], // by default, algolia excludes 'query'. We're including that
})
